export default __webpack_public_path__ + "static/media/noresults.cd398398.svg";